import { MotionFadeIn } from '@mfw/components';
import { Helmet } from 'react-helmet-async';
import classNames from 'classnames';
import React from 'react';

import PageContent from './PageContent/PageContent';
import PageHeader from './PageHeader/PageHeader';
import PageFooter from './PageFooter/PageFooter';
import PageActions from './PageActions';
import PageLayout from './PageLayout';
import './Page.scss';

export interface PageProps {
  children: JSX.Element | JSX.Element[] | false | null | undefined;
  description?: string;
  className?: string;
  animated?: boolean;
  title?: string;
}

const Page = ({
  animated = true,
  children,
  className,
  description,
  title,
}: PageProps) => {
  let footer;
  let header;
  let content;

  function traverseChildren(child: JSX.Element) {
    switch (child.type) {
      case PageHeader:
        header = child;
        break;
      case PageFooter:
        footer = child;
        break;
      case PageContent:
        content = child;
        break;
      default:
        if (typeof child.type === 'function') {
          const renderedChild = child.type(child.props); // Manually render the component
          traverseChildren(renderedChild);
        }
    }
  }

  React.Children.forEach(children, (child) => {
    if (!child) return;
    traverseChildren(child);
  });

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta content={description} name="description" />
      </Helmet>
      <div className={classNames('Mfw-Page-root', className)}>
        <MotionFadeIn animated={animated}>{header}</MotionFadeIn>
        {content}
        {footer}
      </div>
    </>
  );
};

Page.Header = PageHeader;
Page.Content = PageContent;
Page.Layout = PageLayout;
Page.Footer = PageFooter;
Page.Actions = PageActions;

export default Page;
